module.exports = __webpack_public_path__ + "img/upgrade_one_module_to_specific_newer.dab029d9.png";